import React from "react";
import { Form } from "react-final-form";
import UiInput, {
  UiInputPasswordWithFinalForm,
} from "../../../_uiComponents/UiInput";
import { useDispatch, useSelector } from "react-redux";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { forgotPasswordChangeValueRequest } from "../../../../_redux/_actions";
import { useTranslation } from "react-i18next";
import { getFingerPrint } from "../../../../_helpers/support.services";
import Validator from "../../../../_helpers/validate.schema";
import { passwordValidatePolicy } from "../../../../_helpers/support.services";
import { specialCharactersCheck } from "../../../../_helpers/support.services";
import * as yup from "yup";
import { UiValidationMessage } from "../../../_uiComponents/common/UiValidationMessage";

export const ResetPasswordForm = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { auth } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  });

  const validateSchema = () =>
    yup.object().shape({
      password: yup
        .string()
        .matches(
          /^[A-Za-z\d!#$%&*()@^+=]+$/,
          t("Some special characters are not allowed."),
        )
        .required(t("This field is required")),
      confirmPassword: yup.string().when("password", {
        is: (val) => passwordValidatePolicy(val),
        then: (schema) => schema.required(t("This field is required")),
        otherwise: (schema) => schema.notRequired(),
      }),
    });

  const onSubmit = async (values) => {
    const fingerPrint = await getFingerPrint();
    const payload = {
      password: values.password,
      confirmPassword: values.confirmPassword,
      uid: fingerPrint,
    };
    dispatch(forgotPasswordChangeValueRequest(payload));
  };

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  const handleButtonClick = (handleSubmit) => {
    handleSubmit();
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={onValidate}
      subscription={{ values: true, hasValidationErrors: true }}
      render={({ handleSubmit, values, form, hasValidationErrors }) => {
        const isPasswordValid = passwordValidatePolicy(values.password);
        React.useEffect(() => {
          if (!isPasswordValid && values.confirmPassword) {
            form.change("confirmPassword", "");
          }
        }, [isPasswordValid, values.confirmPassword, form]);

        return (
          <form onSubmit={handleSubmit}>
            <UiInputPasswordWithFinalForm
              name="password"
              id="setting-change-password-field"
              label={t("Password")}
              type="password"
              minLength="8"
              maxLength="32"
              varient="outlined"
              required
              passwordValidatePolicy={passwordValidatePolicy}
              specialCharactersCheck={specialCharactersCheck}
              enableStrength
              enableConditions
            />

            <div className={!isPasswordValid ? "df-reset-pw-form" : ""}>
              <UiInput
                name="confirmPassword"
                id="setting-change-password-confirm-password-field"
                label={t("Confirm Password")}
                required
                type="password"
                maxLength="32"
                varient="outlined"
                disabled={!isPasswordValid}
              />
            </div>

            {isPasswordValid &&
              values.confirmPassword &&
              values.confirmPassword !== values.password && (
                <UiValidationMessage
                  message={t("Both passwords do not match.")}
                />
              )}

            <UiButton
              className="df-ui-dark-bg-btn w-100 mt-2"
              name={t("Next")}
              type="button"
              disabled={
                hasValidationErrors ||
                !isPasswordValid ||
                values.confirmPassword !== values.password
              }
              onClick={() => handleButtonClick(handleSubmit)}
            />
          </form>
        );
      }}
    />
  );
};
